module.exports = __webpack_public_path__ + "static/media/tata.a9851c14.png";